import React, { useState, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { noop } from 'lodash-es';
import { Row, Col, Label, Input } from 'reactstrap';
import { BASICS_SCREEN_FLOWS } from 'site-modules/financing/constants/steps';
import { updateCreativeId } from 'client/site-modules/financing/utils/update-creative-id';

import './basics-screen.scss';

export function BasicsScreen({
  changePageState = noop,
  isMatchingVIN = false,
  setFormData = noop,
  enableNextBtn = noop,
  isPreVinFlow = false,
}) {
  const [selectedFlow, setSelectedFlow] = useState('');

  useEffect(
    () => {
      if (selectedFlow) {
        changePageState(selectedFlow);
        enableNextBtn(true);
        setFormData({ requestType: selectedFlow });
      }
    },
    /* eslint-disable react-hooks/exhaustive-deps */
    [selectedFlow]
  );

  const handleChange = useCallback(e => {
    setSelectedFlow(e.target.value);
    enableNextBtn(true);
    setFormData({ requestType: e.target.value });
  }, []);

  return (
    <div
      className="my-2"
      data-tracking-parent={updateCreativeId({ isPreVinFlow, isMatchingVIN, trackingParent: 'basics' })}
    >
      <fieldset>
        <legend className="visually-hidden">Basics flow</legend>
        <Row className="px-1_25 justify-content-between">
          {BASICS_SCREEN_FLOWS.map(({ type, description, icon }) => {
            const isChecked = selectedFlow === type;
            return (
              <Col xs={6} data-testid={type} key={type} className="flow-container p-0">
                <Input
                  type="radio"
                  name="basicsFlow"
                  className="pos-a custom-input"
                  id={`radio-${type}`}
                  value={type}
                  onChange={handleChange}
                  data-testid={`radio${type}`}
                  data-tracking-id="start_pre_qualification"
                  data-tracking-value={type.toLowerCase()}
                  tabIndex={0}
                  aria-required
                />
                <Label
                  for={`radio-${type}`}
                  className={classnames('pos-r h-100 m-0 p-1 text-center radio-label', { selected: isChecked })}
                >
                  <div
                    className={classnames('icon-wrapper rounded-circle mx-auto mb-0_75 d-flex align-items-center', {
                      'bg-primary': isChecked,
                    })}
                  >
                    <span
                      aria-hidden="true"
                      className={classnames(icon, 'size-24 d-block mx-auto', {
                        'text-primary': !isChecked,
                        'text-white': isChecked,
                      })}
                    />
                  </div>
                  <div className="fw-bold text-gray-darker mb-0_5">{type}</div>
                  <div className="medium text-gray-dark">{description}</div>
                </Label>
              </Col>
            );
          })}
        </Row>
      </fieldset>
      <div className="disclaimer-wrapper medium p-1 mt-1_5 d-flex align-items-center text-gray-darker">
        <i className="icon-shield-check text-primary size-24 me-1" aria-hidden />
        <span>
          Don&apos;t worry, there is <strong>no impact to your credit score.</strong>
        </span>
      </div>
    </div>
  );
}

BasicsScreen.propTypes = {
  changePageState: PropTypes.func,
  isMatchingVIN: PropTypes.bool,
  setFormData: PropTypes.func,
  enableNextBtn: PropTypes.func,
  isPreVinFlow: PropTypes.bool,
};
